import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { SectorService } from '../../../../core/services/sector/sector';
import { LoadingService } from '../../../../core/services/loading/loading';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Sector, SectorDTO } from '../../../../core/models/sector.interface';
import { FormUtils } from '../../../../shared/utils';
import { HttpErrorResponse } from '@angular/common/http';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import {
  OptionSelect,
  SearchSelect,
} from '../../../../shared/components/search-select/search-select';
import { ComponentService } from '../../../../core/services/component/component';
import { Componente } from '../../../../core/models/component.interface';
import { switchMap } from 'rxjs';
import { TermPipe } from '../../../../shared/pipes/term.pipe';
import { TermKey } from '../../../../core/models/terminology.interface';

@Component({
  selector: 'app-sector-form',
  imports: [
    MatFormField,
    ReactiveFormsModule,
    MatLabel,
    MatInput,
    MatError,
    MatIcon,
    MatIconModule,
    FormsModule,
    SearchSelect,
    TermPipe,
  ],
  templateUrl: './sector-form.html',
  styleUrl: './sector-form.scss',
})
export class SectorForm {
  sector: string | null = null;
  errorMsg: string[] | null = null;
  sectorSelected: Sector | null = null;
  componentSelected: OptionSelect[] = [];
  listComponents: Componente[] = [];
  selectComponent: OptionSelect | null = null;
  componenteSeleccionado: Componente | null = null;
  private formBuilder = inject(FormBuilder);
  termKey = TermKey;

  constructor(
    private dialogRef: MatDialogRef<SectorForm>,
    private toastr: ToastrService,
    private serviceSector: SectorService,
    private loadingService: LoadingService,
    private componentService: ComponentService,
  ) {}

  ngOnInit(): void {
    this.fetchComponent();
    this.serviceSector.asyncErrorValidation$.subscribe((error) => {
      if (error) {
        this.errorMsg = FormUtils.parseErrorMsgs(error);
      }
    });
  }

  private fetchComponent() {
    this.componentService
      .getComponents()
      .pipe(
        switchMap((components) => {
          this.listComponents = components;
          this.componentSelected = this.componentService.getOptionComponent(components);
          return this.serviceSector.selectedsector$;
        }),
      )
      .subscribe((sector) => {
        if (sector) {
          this.sector = String(sector.id);
          this.sectorSelected = sector;
          this.sectorForm.patchValue({
            ...this.sectorSelected,
            component: this.sectorSelected.component?.id || 0,
          });
          const componentOpt = this.componentSelected.find((el) => {
            if (this.sectorSelected) {
              return el.value === this.sectorSelected.component?.id;
            }
            return false;
          });
          if (typeof componentOpt !== 'undefined') {
            this.selectComponent = componentOpt;
          }
        }
      });
  }

  sectorForm = this.formBuilder.group({
    name: ['', [Validators.required, Validators.maxLength(256)]],
    objective: ['', [Validators.required]],
    risk: ['', [Validators.required, Validators.maxLength(256)]],
    component: [0, [Validators.required]],
  });

  getComponent(id: number) {
    const index = this.listComponents.findIndex((component) => component.id === id);
    this.componenteSeleccionado = this.listComponents[index];
  }

  onComponentSelected(component: OptionSelect) {
    this.sectorForm.get('component')?.setValue(component.value as number);
    this.getComponent(component.value as number);
  }

  closeDialog() {
    this.dialogRef.close();
  }

  saveSector() {
    const payload = this.sectorForm.value as SectorDTO;
    if (this.sectorForm.status === 'VALID' && !this.sector) {
      this.loadingService.show(true);
      this.serviceSector.createSector(payload).subscribe({
        next: (sector) => {
          this.loadingService.show(false);
          const msg = `El sector ${sector.name} fue CREADO correctamente!`;
          this.toastr.success(msg, 'Exitoso!', {
            progressBar: true,
            timeOut: 5000,
          });
          this.dialogRef.close();
        },
        error: ({}: HttpErrorResponse) => {
          if (this.errorMsg) {
            this.loadingService.show(false);
            this.toastr.error('Error: ' + this.errorMsg, undefined, {
              progressBar: true,
              timeOut: 5000,
            });
          }
        },
      });
    } else if (this.sectorForm.status === 'VALID' && this.sector) {
      this.loadingService.show(true);
      const id = Number(this.sector);
      this.serviceSector.UpdateSector(id, { ...payload, id: id }).subscribe({
        next: (sector) => {
          this.loadingService.show(false);
          const msg = `El sector ${sector.name} fue EDITADO correctamente!`;
          this.toastr.success(msg, 'Exitoso!', {
            progressBar: true,
            timeOut: 5000,
          });
          this.dialogRef.close();
        },
        error: ({}: HttpErrorResponse) => {
          if (this.errorMsg) {
            this.loadingService.show(false);
            this.toastr.error('Error: ' + this.errorMsg, undefined, {
              progressBar: true,
              timeOut: 5000,
            });
          }
        },
      });
    }
  }
  getComponentValue() {
    return this.selectComponent;
  }
}
